// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8eb84a31","455":"c60822d7","644":"8be37115"}[chunkId] + ".chunk.js";
};